<template>
  <div>
    <div class="text-left pd-b-3 flex-display ai-center js-between">
      <h2 class="mg-less">เพิ่มวิชา</h2>
    
      <a
        v-if="!subjectNumber ||  subjectList.length < subjectNumber"
        @click="
          $router.push(`/subject/create/?courseId=${$route.query.courseId}`)
        "
        class="color-primary-light"
        >+ เพิ่มวิชา</a
      >
    </div>
    <div>
      <el-table
        v-if="showTable"
        v-loading="loading"
        :data="subjectList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        empty-text="ไม่พบข้อมูล"
        :default-sort="{ prop: 'index', order: 'ascending' }"
      >
        <el-table-column
          prop="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          width="80"
          sortable
        ></el-table-column>
        <el-table-column
          prop="name"
          label="ชื่อวิชา"
          header-align="center"
          sortable
          :width="widthMax < 767.98 ? '170' : ''"
        ></el-table-column>
        <el-table-column
          prop="durationTime"
          label="เปิด-ปิดวิชา"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.durationTime.open | dateTimeThShort }} -
            {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}
          </template>
        </el-table-column>
        <el-table-column
          prop="topics"
          label="จำนวนบทเรียน"
          :width="
            widthMax < 767.98
              ? '90'
              : widthMax < 1199
              ? '90'
              : widthMax > 1200
              ? '120'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.activity.topic == 'undefined' || scope.row.activity.topic">{{scope.row.topics}}</span>
            <span v-else class="pd-x-4 color-gray">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="preTest"
          label="แบบทดสอบก่อนเรียน"
          :width="
            widthMax < 767.98
              ? '90'
              : widthMax < 1199
              ? '90'
              : widthMax > 1200
              ? '105'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.preTest"
              class="pd-x-4 color-success"
            >
              <i class="fas fa-check"></i>
            </span>
            <span v-else class=" color-danger-light">รอเพิ่มข้อสอบ</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="activity"
          label="กระดานถาม - ตอบระหว่างเรียน"
          :width="
            widthMax < 767.98
              ? '90'
              : widthMax < 1199
              ? '90'
              : widthMax > 1200
              ? '105'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                typeof scope.row.activity.discussion !== 'undefined' &&
                scope.row.activity.discussion
              "
              class="pd-x-4 color-success"
            >
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="pd-x-4 color-gray">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="activity"
          label="งานที่ได้รับมอบหมาย"
          :width="
            widthMax < 767.98
              ? '95'
              : widthMax < 1199
              ? '92'
              : widthMax > 1200
              ? '105'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                typeof scope.row.activity.assignment !== 'undefined' &&
                scope.row.activity.assignment
              "
              class="pd-x-4 color-success"
            >
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="pd-x-4 color-gray">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="activity"
          label="แบบทดสอบหลังเรียน"
          :width="
            widthMax < 767.98
              ? '95'
              : widthMax < 1199
              ? '92'
              : widthMax > 1200
              ? '105'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                typeof scope.row.activity.postTest !== 'undefined' &&
                scope.row.activity.postTest
              "
              class="pd-x-4 color-success"
            >
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="pd-x-4 color-gray">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="activity"
          label="หัวข้อ (วีดีโอ)"
          :width="
            widthMax < 767.98
              ? '95'
              : widthMax < 1199
              ? '92'
              : widthMax > 1200
              ? '105'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                typeof scope.row.activity.topic == 'undefined' || scope.row.activity.topic
              "
              class="pd-x-4 color-success"
            >
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="pd-x-4 color-gray">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          label="วันที่และเวลาที่อัปเดต"
          :width="
            widthMax < 767.98
              ? '120'
              : widthMax < 1199
              ? '120'
              : widthMax > 1200
              ? '250'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateTimeTh
          }}</template>
        </el-table-column>
        <el-table-column label width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="
                    $router.push(
                      `/subject/update?courseId=${$route.query.courseId}&subjectId=${scope.row._id}`
                    )
                  "
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <div class="box-action">
                <el-popconfirm
                  confirmButtonText="ใช่"
                  cancelButtonText="ไม่"
                  icon="el-icon-info"
                  iconColor="red"
                  title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                  @onConfirm="delSubject(scope.row._id)"
                >
                  <div
                    slot="reference"
                    class="circle-action color-bg-danger-lighter"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import { HTTP } from "@/service/axios.js";

export default {
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  props: {
    courseName: {
      type: String,
      default() {
        return "";
      },
    },
    subjectNumber: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      loading: true,
      subjectList: [],
    };
  },
  mounted() {
    this.fetchSubject();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    delSubject(id) {
      this.loading = true;
      let obj = {
        courseId: this.$route.query.courseId,
        subjectId: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/subject`, obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchSubject();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delSubject error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchSubject() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`course/${this.$route.query.courseId}`)
        .then((res) => {
          if (res.data.success) {
            this.subjectList = res.data.obj.subject;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchSubject error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>